import Vue from 'vue'

import { MeGQL } from '@/graphql/queries'

const cachedState = Vue.observable({
  hasActiveContracts: false
})

export default {
  apollo: {
    me: {
      query: MeGQL
    }
  },

  computed: {
    hasActiveContracts () {
      return cachedState.hasActiveContracts
    },
    hasActiveContractsFromApollo () {
      return this.me && this.me.availableMerchants.length && !this.me.availableMerchants[0].draft
    }
  },

  watch: {
    hasActiveContractsFromApollo (val, oldVal) {
      if (val !== oldVal) {
        cachedState.hasActiveContracts = val
      }
    }
  }
}

export const clearContractsStatus = () => {
  cachedState.hasActiveContracts = false
}
